export default function(model) {
	return {
		model: model,
		isMobile: false,

		async init() {
			this.checkMobile();
			window.addEventListener('resize', () => this.checkMobile());

			// Si on est sur mobile, on ne charge pas le modèle 3D
			if (this.isMobile) {
				return;
			}

			await this.loadBabylonFromCDN();

			const COLORS = ["#fce303", "#fa3525", "#1d2d3d"];
			let colorIndex = 0;

			function frameSceneWithArcCamera(scene, canvas, {
				alpha = Math.PI * 0.25,
				beta = Math.PI * 0.25,
				fov = BABYLON.Tools.ToRadians(50),
				margin = 1.2,
				minZ = 0.01,
				maxZ = 10000,
			} = {}) {
				const { min, max } = scene.getWorldExtends();
				const center = min.add(max).scale(0.5);
				const size = max.subtract(min);
				const radius = 0.5 * Math.sqrt(size.x * size.x + size.y * size.y + size.z * size.z);

				const cam = new BABYLON.ArcRotateCamera("FramingArcCam", alpha, beta, 1, center, scene);
				cam.fov = fov;
				cam.fovMode = BABYLON.Camera.FOVMODE_VERTICAL_FIXED;
				cam.minZ = minZ;
				cam.maxZ = maxZ;

				const d = (radius * margin) / Math.sin(cam.fov * 0.5);
				cam.radius = isFinite(d) && d > 0 ? d : radius || 2;

				cam.lowerRadiusLimit = cam.radius * 0.1;
				cam.upperRadiusLimit = cam.radius * 10;
				cam.wheelPrecision = 200;

				cam.attachControl(canvas, true);
				scene.activeCamera = cam;

				canvas.style.touchAction = "pan-y";

				return { camera: cam, center, radius };
			}

			async function createViewer(canvas, modelUrl) {
				const engine = new BABYLON.Engine(canvas, true, {
					preserveDrawingBuffer: true,
					stencil: true,
					antialias: true,
					adaptToDeviceRatio: true
				});
				const scene = new BABYLON.Scene(engine);
				scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
				scene.environmentTexture = new BABYLON.CubeTexture(gilac.assets_url+"/3d/studio.env", scene);
				scene.environmentIntensity = 0.25;

				const light = new BABYLON.DirectionalLight("dir", new BABYLON.Vector3(-1, -2, -1), scene);
				light.intensity = 3.0;

				engine.loadingUIBackgroundColor = "transparent";
				engine.loadingUIText = "";

				// Ajout d'une lumière hémisphérique pour éclaircir l'ensemble de la scène
				const hemisphericLight = new BABYLON.HemisphericLight("hemiLight", new BABYLON.Vector3(0, 1, 0), scene);
				hemisphericLight.intensity = 0.3;
				hemisphericLight.diffuse = new BABYLON.Color3(1, 1, 1);
				hemisphericLight.groundColor = new BABYLON.Color3(0.5, 0.5, 0.5);

				await BABYLON.AppendSceneAsync(modelUrl, scene);

				const { camera } = frameSceneWithArcCamera(scene, canvas, {
					margin: 1.25,
					alpha: Math.PI * 1.25,
					beta: Math.PI * 0.33,
					fov: BABYLON.Tools.ToRadians(50)
				});

				const r = camera.radius;
				camera.lowerRadiusLimit = r;
				camera.upperRadiusLimit = r;
				camera.panningSensibility = 0;
				camera.panningInertia = 0;

				// Configuration de la rotation automatique
				camera.useAutoRotationBehavior = true;
				camera.autoRotationBehavior.idleRotationSpeed = 0.05; // Vitesse de rotation
				camera.autoRotationBehavior.idleRotationWaitTime = 0; // Démarrer immédiatement

				// Désactiver la rotation auto lors de l'interaction utilisateur
				const self = this;
				canvas.addEventListener("pointerdown", function() {
					if (camera.useAutoRotationBehavior) {
						camera.useAutoRotationBehavior = false;
					}
				});


				engine.runRenderLoop(() => scene.render());
				const onResize = () => engine.resize();
				window.addEventListener("resize", onResize);
				const dispose = () => {
					window.removeEventListener("resize", onResize);
					engine.dispose();
				};
				return { engine, scene, camera, dispose };
			}

			let viewer;

			(async () => {
				viewer = await createViewer(document.getElementById("eis3d_view-"+this.model), gilac.assets_url+"/3d/"+this.model+".glb");
				if (this.model === "alveole") {
					viewer.scene.getMaterialByName("alveole_MAT").albedoColor = BABYLON.Color3.FromHexString(COLORS[0]);
				}
			})();

			if (this.model !== "alveole") {
				return;
			}

			// Changement de couleur alveole
			const dotsContainer = document.getElementById("alveole-color");

			// Créer un point pour chaque couleur
			COLORS.forEach((color, index) => {
				const dot = document.createElement("div");
				dot.classList.add("dot");
				dot.style.background = color;
				if (index === 0) {
					dot.classList.add("active");
				}

				dot.addEventListener("click", () => {
					colorIndex = index;
					document.querySelectorAll(".dot").forEach((d, i) => {
						if (i === index) {
							d.classList.add("active");
						} else {
							d.classList.remove("active");
						}
					});

					// Changer la couleur du modèle 3D
					const mat = viewer.scene.getMaterialByName("alveole_MAT");
					if (!mat) return;

					if (mat instanceof BABYLON.PBRMaterial)
						mat.albedoColor = BABYLON.Color3.FromHexString(color);
					else if (mat instanceof BABYLON.StandardMaterial)
						mat.diffuseColor = BABYLON.Color3.FromHexString(color);
				});

				dotsContainer.appendChild(dot);
			});

		},

		async loadBabylonFromCDN() {
			if (this.babylonLoaded) return;

			return new Promise((resolve) => {
				const scriptCore = document.createElement('script');
				scriptCore.src = 'https://cdn.babylonjs.com/babylon.js';
				scriptCore.async = true;

				scriptCore.onload = () => {
					const scriptLoader = document.createElement('script');
					scriptLoader.src = 'https://cdn.babylonjs.com/loaders/babylonjs.loaders.min.js';
					scriptLoader.async = true;
					scriptLoader.onload = () => {
						this.babylonLoaded = true;
						resolve();
					};
					document.body.appendChild(scriptLoader);
				};

				document.body.appendChild(scriptCore);
			});
		},

		checkMobile() {
			this.isMobile = window.innerWidth < 768;
		}
	}
}
